export enum SnackBarType {
    SUCCESS = 'Success',
    ERROR = 'Error',
    WARN = 'Warn',
    INFO = 'Info'
}